import { render, staticRenderFns } from "./AccessorialsDelivery.vue?vue&type=template&id=60b86304&scoped=true&"
import script from "./AccessorialsDelivery.vue?vue&type=script&lang=js&"
export * from "./AccessorialsDelivery.vue?vue&type=script&lang=js&"
import style0 from "./AccessorialsDelivery.vue?vue&type=style&index=0&id=60b86304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b86304",
  null
  
)

export default component.exports